import React from "react";
import GridCard from "./GridCard";
import { useShoutouts } from "./hooks/useShoutouts";

interface Props {
  username: string;
  year: string;
  quarter: number;
  display: { Shoutout: boolean };
}

const ShoutoutCard: React.FC<Props> = ({
  username,
  year,
  quarter,
  display,
}) => {
  const enabled = !!username && !!year && display.Shoutout;
  const { data, loading } = useShoutouts(username, year, quarter, enabled);

  if (!display.Shoutout) return null;

  const cardBase =
    "col-span-12 p-4 rounded-lg shadow bg-white dark:bg-gray-900 border border-gray-300 dark:border-gray-700";

  return (
    <div className={cardBase}>
      {loading ? (
        <div className="flex flex-col items-center justify-center py-8">
          <svg
            className="animate-spin h-8 w-8 text-blue-500 dark:text-blue-400 mb-2"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v8z"
            />
          </svg>

          <span className="text-gray-700 dark:text-gray-300">
            Loading Shoutouts...
          </span>
        </div>
      ) : data && data.length > 0 ? (
        <GridCard
          title="Shoutouts"
          headers={["Created", "Shoutout Text", "Category"]}
          data={data}
        />
      ) : (
        <div className="py-4 text-gray-500 dark:text-gray-400 italic">
          No shoutouts available for this period.
        </div>
      )}
    </div>
  );
};

export default ShoutoutCard;